<template>
  <div>
    <div class="mb-12 to-hide">
      <div
        v-if="currentStep > documentSteps.length"
        class="d-flex justify-space-between align-center mb-3"
      >
        <div class="txt-head black--text">
          โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์ (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)
        </div>
        <!--        <Button-->
        <!--            theme="8"-->
        <!--            @click.native="convertPDF()"-->
        <!--        >-->
        <!--          jsPDF+html2canvas-->
        <!--        </Button>-->
        <Button theme="8" @click.native="print()" v-if="$route.query.preview">
          Export PDF
        </Button>
        <!--        <Button-->
        <!--            theme="8"-->
        <!--        >-->
        <!--          Export PDF-->
        <!--        </Button>-->
      </div>
      <divcard class="d-flex justify-space-between mb-2" style="gap: 24px">
        <div class="d-flex" style="gap: 24px">
          <div>
            <v-img
              :src="require('../../assets/mhesr.png')"
              min-width="100"
              max-width="100"
              aspect-ratio="1"
            ></v-img>
          </div>

          <div>
            <div class="page-title">
              สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม
              (สป.อว.)
              <!-- For Dev -->
              <Button
                v-if="currentStep == 2 || currentStep == 3 || currentStep == 4"
                theme="4"
                min-width="120px"
                :disabled="isLoading"
                @onClick="autoField(currentStep, plan_code)"
              >
                autoField - step {{ currentStep }} - {{ plan_code }}
              </Button>
              <!-- /*For Dev -->
            </div>
            <div class="d-flex align-center" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="jam:clock"
              ></Iconify>
              <span>{{
                toDateRangeFormat(
                  masterData.project_accept_round?.start_date,
                  masterData.project_accept_round?.end_date
                )
              }}</span>
            </div>

            <div class="d-flex align-center" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="jam:clock"
                color="var(--theme-color-three)"
              ></Iconify>
              <span
                >หน่วยงานรับรองจนถึงวันที่
                {{
                  toDateFormat(masterData.project_accept_round?.consider_date)
                }}</span
              >
            </div>

            <!-- <div class="d-flex align-center" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="ion:document-text"
                color="var(--theme-color-nine)"
              ></Iconify>
              <div>
                <div class="container-form-title">
                  แบบฟอร์ม C
                </div>
              </div>
            </div> -->

            <div
              v-if="docTypeName()"
              class="d-flex align-center"
              style="gap: 18px"
            >
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="ion:mail-unread"
              ></Iconify>
              <span>{{ docTypeName() }}</span>
            </div>
          </div>
        </div>

        <div class="d-flex align-center" style="gap: 18px">
          <div class="form-tag">
            <div>แบบฟอร์ม</div>
            <div>C</div>
          </div>

          <div class="budget-tag">
            <div>ปี งปม.</div>
            <div>
              {{
                masterData.project_accept_round?.plan?.main_project?.fiscal_year ||
                masterData.main_project?.fiscal_year
              }}
            </div>
          </div>
        </div>
      </divcard>

      <StatusStep
        v-if="currentStep <= documentSteps.length || !$route.query.preview"
        :current-step="currentStep"
        :steps="documentSteps"
        @onClick="jumpStep"
      ></StatusStep>
    </div>

    <!--  Form switcher  -->
    <div>
      <CFormGeneral
        v-if="currentStep === 1 && !$route.query.preview"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f1_formKey"
      ></CFormGeneral>

      <CFormProject_SP
        v-if="currentStep === 2 && plan_code === 'SP'"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f2_formKey"
      ></CFormProject_SP>
      <CFormProject_IRTC
        v-if="currentStep === 2 && plan_code === 'IRTC'"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f2_formKey"
      ></CFormProject_IRTC>
      <CFormProject_STI
        v-if="currentStep === 2 && plan_code === 'STI'"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f2_formKey"
      ></CFormProject_STI>
      <CFormProject_CR
        v-if="currentStep === 2 && plan_code === 'CR'"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f2_formKey"
      ></CFormProject_CR>

      <CFormPlan
        v-if="currentStep === 3"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f3_formKey"
      ></CFormPlan>
      <CFormOOI
        v-if="currentStep === 4"
        :masterData="{ ...masterData, updateId }"
        :is-same-id="isSameId()"
        :key="f4_formKey"
      ></CFormOOI>
      <CFormAttachment
        v-if="currentStep === 5"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f5_formKey"
      ></CFormAttachment>
      <CFormSummary
        v-if="currentStep === 6"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f6_formKey"
      ></CFormSummary>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between to-hide">
      <Button theme="2" @onClick="onCancel">ยกเลิก</Button>

      <div class="flex-center" v-if="!$route.query.preview">
        <!-- For Dev -->
        <!-- <Button theme="4" min-width="120px" :disabled="isLoading" @onClick="summaryForm">Summary</Button> -->
        <!-- /*For Dev -->
        <Button
          v-if="currentStep !== 1"
          theme="3"
          min-width="120px"
          :disabled="isLoading"
          @onClick="backForm"
        >
          &lt; ย้อนกลับ
        </Button>

        <Button
          theme="4"
          min-width="120px"
          :disabled="isLoading"
          @onClick="saveDraft"
          >บันทึกฉบับร่าง</Button
        >
        <Button
          theme="3"
          min-width="120px"
          :disabled="isLoading || doNotSubmit"
          @onClick="nextForm"
        >
          {{ currentStep === 6 ? "ยื่นโครงการ" : "ถัดไป >" }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep";
import Button from "../../components/input/Button";
import {
  eventBus,
  toDateFormat,
  toDateRangeFormat,
  validateEmail,
} from "../../plugins/global-funcs";
import CFormGeneral from "./C/CFormGeneral";
import CFormProject_IRTC from "./C/CFormProject/CFormProject_IRTC";
import CFormProject_SP from "./C/CFormProject/CFormProject_SP";
import CFormProject_STI from "./C/CFormProject/CFormProject_STI";
import CFormProject_CR from "./C/CFormProject/CFormProject_CR";
import CFormPlan from "./C/CFormPlan";
import CFormOOI from "./C/CFormOOI";
import CFormAttachment from "./C/CFormAttachment";
import CFormSummary from "./C/CFormSummary";
import { mapState } from "vuex";
import { clearCookie__c } from "@/plugins/cookies";
import { format } from "date-fns";
import { th } from "date-fns/locale";
// import jsPDF from "jspdf"
// import html2canvas from "html2canvas"
// import vueHtml2pdf from "vue-html2pdf"

export default {
  name: "FormC",
  components: {
    CFormProject_STI,
    StatusStep,
    Button,
    CFormGeneral,
    CFormProject_IRTC,
    CFormProject_SP,
    CFormProject_CR,
    CFormPlan,
    CFormOOI,
    CFormAttachment,
    CFormSummary,
    // html2canvas,
    // jsPDF,
    // vueHtml2pdf,
  },
  data() {
    return {
      toDateFormat,
      toDateRangeFormat,
      currentStep: 1,
      doNotSubmit: false,
      documentSteps: [
        {
          no: 1,
          name: "ข้อมูลทั่วไป",
        },
        {
          no: 2,
          name: "ข้อมูลโครงการ",
        },
        {
          no: 3,
          name: "แผนงาน",
        },
        {
          no: 4,
          name: "ผลผลิต",
        },
        {
          no: 5,
          name: "เอกสารแนบ",
        },
      ],
      formGeneral: {},
      formProject: {},
      formPlan: {},
      formOOI: {},
      formAttachment: {},
      masterData: {},
      updateId: undefined,
      f1_formKey: 0,
      f2_formKey: 0,
      f3_formKey: 0,
      f4_formKey: 0,
      f5_formKey: 0,
      f6_formKey: 0,
      plan_code: "",
      shortMonths: [],
    };
  },
  async created() {
    if (
      !this.$route.query.round_id &&
      !this.$route.query.id &&
      !this.$route.query.inception_id
    )
      return this.onCancel();
    await this.getMasterData();
    if (this.$route.query.preview) return this.summaryForm();
    this.retrieveForms();
    eventBus.$emit("customBcName", this?.masterData?.plan_master?.plan_name_th);
    //for dev
    // this.currentStep = 3;
  },
  beforeDestroy() {
    eventBus.$off("cFormGeneralSend");
    eventBus.$off("cFormGeneral");
    eventBus.$off("cFormProjectSend");
    eventBus.$off("cFormProject");
    eventBus.$off("cFormPlanSend");
    eventBus.$off("cFormPlan");
    eventBus.$off("cFormPlanSetData");
    eventBus.$off("cFormOOISend");
    eventBus.$off("cFormOOI");
    eventBus.$off("cFormOOISetData");
    eventBus.$off("cFormAttachmentSend");
    eventBus.$off("cFormAttachment");
    eventBus.$off("cFormAttachmentSetData");
    eventBus.$off("cFormAbleToSubmit");
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
      userInfo: (state) => state.Auth.User,
      cFormId: (state) => state.CForm.id,
      userRole: (state) => state.Auth.User.user_type,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  methods: {
    jumpStep(step) {
      if (step == this.currentStep) return;
      if (this.isLoading) {
        this.$store.commit("General/setModal", {
          title: "Wait a moment.",
          text: "Preparing data please wait...",
          theme: "warning",
          showCancel: false,
          buttonText: "OK",
        });
        return;
      }
      if (this.$route.query.id || this.updateId) {
        this.currentStep = parseInt(step);
        this.$vuetify.goTo("#app");
        this.doNotSubmit = false;
      } else {
        this.$store.commit("General/setModal", {
          title: "Complete this step first!",
          text: "Complete the first step then you can jump",
          theme: "error",
          showCancel: false,
          buttonText: "OK",
        });
      }
    },
    isSameId() {
      return !!this.$route.query.id && this.$route.query.id == this.cFormId;
    },
    backForm() {
      if (this.currentStep <= 1) return;
      // don't save when back from summary page
      if (this.currentStep <= this.documentSteps.length) {
        this.saveDraft();
        this.doNotSubmit = false;
      }
      this.currentStep -= 1;
      this.doNotSubmit = false;
      this.$vuetify.goTo("#app");
    },
    async nextForm() {
      if (this.currentStep > this.documentSteps.length) {
        await this.saveDraft(true);
        return this.$router.push({ name: "PlanOfferList" });
        // return this.$router.push({ name: 'FormCPreview' })
      }
      let error = await this.saveDraft();
      console.log("error", error);
      if (error) return;
      this.currentStep += 1;
      this.$vuetify.goTo("#app");
    },

    // For Dev
    summaryForm() {
      this.currentStep = this.documentSteps.length + 1;
      this.$vuetify.goTo("#app");
    },
    async saveDraft(isSubmit = false) {
      // this.requestForm(this.currentStep)
      this.requestForm("all");

      // validate formProject
      // if (this.formProject) {
      //   if (
      //     (this.formProject.s2_p1_email &&
      //       !validateEmail(this.formProject.s2_p1_email)) ||
      //     (this.formProject.s2_p2_pm_email &&
      //       !validateEmail(this.formProject.s2_p2_pm_email)) ||
      //     (this.formProject.s2_p2_proj_coord_email &&
      //       !validateEmail(this.formProject.s2_p2_proj_coord_email)) ||
      //     (this.formProject.s2_p3_prv_org_email &&
      //       !validateEmail(this.formProject.s2_p3_prv_org_email))
      //   ) {
      //     this.$store.commit("General/setModal", {
      //       title: "ข้อมูลไม่ถูก  ต้อง",
      //       text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //       theme: "error",
      //       showCancel: false,
      //       buttonText: "OK",
      //     });
      //     return true;
      //   }
      // }

      // if (this.formProject && this.formProject.project_teams) {
      //   const teams = this.formProject.project_teams;
      //   teams.forEach((team) => {
      //     if (team.s2_p1_email && !validateEmail(team.s2_p1_email)) {
      //       this.$store.commit("General/setModal", {
      //         title: "ข้อมูลไม่ถูกต้อง",
      //         text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //         theme: "error",
      //         showCancel: false,
      //         buttonText: "OK",
      //       });
      //       return true;
      //     }
      //   });
      // }

      // console.log("formOOI.attachments", this.formOOI.attachments);
      // console.log("formAttachment before", this.formAttachment);

      if (this.formOOI.attachments && this.formOOI.attachments.length > 0) {
        // deletion
        // filter out from formAttachment if formAttachment.doc_type == 'annex' and not in formOOI.attachments
        this.formAttachment = this.formAttachment.filter((item) => {
          if (item.doc_type == "annex") {
            let found = this.formOOI.attachments.find((item2) => {
              return item2.full_path == item.full_path;
            });
            if (!found) {
              return false;
            }
          }
          return true;
        });
      }

      let payload = {
        budget_amount: this.formPlan.budget_amount,
        project_section_general_info: this.formGeneral,

        // incubation_company
        incubation_companies: this.formOOI.incubation_companies,

        // company contacts
        company_contacts: this.formGeneral.company_contacts,

        // job_delivery_details
        job_delivery_details: this.formPlan.job_delivery_details,

        project_section: {
          ...this.formProject,
          ...this.formOOI,
          project_teams: undefined,
          kpi_sub_values: undefined,
          s3_p4_final_day: this.formPlan.s3_p4_final_day,
          s3_p4_progress_day: this.formPlan.s3_p4_progress_day,
          s3_p4_progress_pct: this.formPlan.s3_p4_progress_pct,
          s3_solution: this.formPlan.s3_solution,
          s3_problem: this.formPlan.s3_problem,
          s3_p3_ip_management: this.formPlan.s3_p3_ip_management,
          s3_p3_problem: this.formPlan.s3_p3_problem,
          s3_p3_solution: this.formPlan.s3_p3_solution,
          s3_p3_interest: this.formPlan.s3_p3_interest,
        },
        project_teams: this.formProject?.project_teams || [],
        project_head_team: this.formProject?.project_head_team || [],
        project_manager_team: this.formProject?.project_manager_team || [],
        project_coordinate_team:
          this.formProject?.project_coordinate_team || [],
        project_section_plan: {
          ...this.formPlan,
          budget_amount: undefined,
          s3_p4_final_day: undefined,
          s3_p4_progress_day: undefined,
          s3_p4_progress_pct: undefined,
          s3_solution: undefined,
          s3_problem: undefined,
          s3_p3_ip_management: undefined,
          s3_p3_problem: undefined,
          s3_p3_solution: undefined,
          s3_p3_interest: undefined,
        },
        kpi_sub_values: this.formOOI.kpi_sub_values
          ? this.formOOI.kpi_sub_values
          : [],
        completed_incubation_company:
          this.formOOI.completed_incubation_company || [],
        attachments: this.formAttachment ? this.formAttachment : [],
        doc_type:
          this.$route.query.doc_type === "progress"
            ? "Progress/Final"
            : undefined,
      };

      console.log("payload", payload);

      //check each this.formAttachment has a File or not
      if (payload.attachments?.length > 0) {
        let uploadPromises = payload.attachments.map((attachment, index) => {
          if (attachment instanceof File) {
            return this.uploadFile(attachment).then((result) => {
              console.log("file ", index, "is uploaded");
              return result;
            });
          } else {
            return Promise.resolve(attachment);
          }
        });
        payload.attachments = await Promise.all(uploadPromises);
      }

      // annex attachments
      if (payload.project_section?.attachments?.length > 0) {
        let uploadPromises = payload.project_section.attachments.map(
          (attachment, index) => {
            if (attachment instanceof File) {
              return this.uploadFile(attachment).then((result) => {
                console.log("file annex", index, "is uploaded");
                result.doc_type = "annex";
                payload.project_section.attachments.splice(index, 1);
                return result;
              });
            } else {
              return Promise.resolve(attachment);
            }
          }
        );
        let results = await Promise.all(uploadPromises);
        payload.project_section.attachments = results;
        // push results to payload.attachments if result not have id
        results.forEach((result) => {
          if (!result.id) {
            payload.attachments.push(result);
          }
        });
      }
      console.log("payload project section", payload.project_section);

      // if(payload) return;

      if (this.$route.query.round_id) {
        payload.project_accept_round_id = this.$route.query.round_id;
      }
      let res;
      if (this.$route.query.id || this.updateId) {
        // case: update
        payload = {
          id: this.$route.query.id || this.updateId,
          payload: {
            ...payload,
            status: isSubmit ? "Submitted1" : "Draft",
            id: undefined,
          },
        };
        if (this.isFinal)
          payload.payload.status = isSubmit ? "Submitted" : "Draft";
        // check inception status
        if (
          this.masterData.form_c &&
          this.masterData.form_c.status === "Inception"
        ) {
          payload.payload.status = isSubmit ? "Submitted2" : "Inception";
        }
        res = await this.$apiFire("CForm/updateFormC", payload);
        if (res && res.id) {
          // success
          this.masterData.form_c = res;
          this.masterData.kpi_masters = res.kpi_masters;
          this.updateFormData(this.currentStep);
          this.updateSubFormComponent();
        } else {
          // error validate
          return true;
        }
      } else {
        // case: store new , inception id
        payload.status = isSubmit ? "Submitted1" : "Draft";
        if (this.isFinal) payload.status = isSubmit ? "Submitted" : "Draft";
        if (this.$route.query.inception_id) {
          payload.inception_id = this.$route.query.inception_id;
        }
        res = await this.$apiFire("CForm/storeFormC", payload);

        if (res) {
          // save id
          this.updateId = res;
          this.$store.commit("CForm/setGeneralForm", this.formGeneral);
          window.history.replaceState(
            {},
            null,
            window.location.href + "&id=" + res
          );
        }
        // update changed data
        this.getMasterData();
      }
      this.$forceUpdate();
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("cFormGeneral");
          break;

        case 2:
          eventBus.$emit("cFormProject");
          break;

        case 3:
          eventBus.$emit("cFormPlan");
          break;

        case 4:
          eventBus.$emit("cFormOOI");
          break;

        case 5:
          eventBus.$emit("cFormAttachment");
          break;

        default:
          eventBus.$emit("cFormGeneral");
          eventBus.$emit("cFormProject");
          eventBus.$emit("cFormPlan");
          eventBus.$emit("cFormOOI");
          eventBus.$emit("cFormAttachment");
          break;
      }
    },
    updateFormData(formStep) {
      switch (formStep) {
        case 3:
          eventBus.$emit("cFormPlanSetData");
          eventBus.$emit("cFormPlan");
          break;

        case 4:
          eventBus.$emit("cFormOOISetData");
          eventBus.$emit("cFormOOI");
          break;

        case 5:
          eventBus.$emit("cFormAttachmentSetData");
          eventBus.$emit("cFormAttachment");
          break;
      }
    },
    retrieveForms() {
      // General form
      eventBus.$on("cFormGeneralSend", (form) => {
        this.formGeneral = form;
        // keep in storage
        this.$store.commit("CForm/setGeneralForm", this.formGeneral);
      });

      // Project form
      eventBus.$on("cFormProjectSend", (form) => {
        this.formProject = form;
        // keep in storage
        this.$store.commit("CForm/setProjectForm", this.formProject);
      });

      // Plan form
      eventBus.$on("cFormPlanSend", (form) => {
        this.formPlan = form;
        // keep in storage
        this.$store.commit("CForm/setPlanForm", this.formPlan);
      });

      // ผลผลิต form
      eventBus.$on("cFormOOISend", (form) => {
        this.formOOI = form;
        // keep in storage
        this.$store.commit("CForm/setOOIForm", this.formOOI);
      });

      // Attachment form
      eventBus.$on("cFormAttachmentSend", (form) => {
        this.formAttachment = form;
        // keep in storage
        this.$store.commit("CForm/setAttachmentForm", this.formAttachment);
      });

      // Allow to submit for the summary page
      eventBus.$on("cFormAbleToSubmit", (bool) => {
        this.doNotSubmit = !bool;
      });
    },
    async getMasterData() {
      let res;
      if (
        this.$route.query.inception_id ||
        this.$route.query.id ||
        this.updateId
      ) {
        let id =
          this.$route.query.inception_id ||
          this.$route.query.id ||
          this.updateId;
        // edit (wait for api)
        res = await this.$apiFire("CForm/getEditMasterFormC", id);
        // update component with changing key
        this.updateSubFormComponent();
      } else {
        // create
        res = await this.$apiFire(
          "CForm/getMasterFormC",
          this.$route.query.round_id
        );
      }
      if (res) {
        this.masterData = res;
        this.plan_code = res.plan_master.plan_code;

        // hard code STI activity
        this.masterData.activity_sti = [
          {
            id: 1,
            name: "กิจกรรมบ่มเพาะ อปก.",
          },
          {
            id: 2,
            name: "กิจกรรม RSP New Release",
          },
          {
            id: 3,
            name: "กิจกรรมเส้นทางสู่นวัตวณิชย์ Research to Market (R2M)",
          },
        ];

        // set data to form for next save
        this.formGeneral = res.form_c?.project_section_general_info || {};
        this.formProject = res.form_c?.project_section || {};
        this.formProject.project_teams = res.form_c?.project_teams || [];
        this.formProject.project_head_team =
          res.form_c?.project_head_team || [];
        this.formProject.project_manager_team =
          res.form_c?.project_manager_team || [];
        this.formProject.project_coordinate_team =
          res.form_c?.project_coordinate_team || [];

        this.formOOI.result_quality =
          res.form_c?.project_section?.result_quality;
        this.formOOI.result_quantity =
          res.form_c?.project_section?.result_quantity;
        this.formOOI.kpi_eco = res.form_c?.project_section?.kpi_eco;
        this.formOOI.kpi_social = res.form_c?.project_section?.kpi_social;
        this.formOOI.impact_quantity =
          res.form_c?.project_section?.impact_quantity;
        this.formOOI.impact_quality =
          res.form_c?.project_section?.impact_quality;
        this.formOOI.s4_p2_quantity =
          res.form_c?.project_section?.s4_p2_quantity;
        this.formOOI.s4_p2_quality = res.form_c?.project_section?.s4_p2_quality;
        this.formOOI.s4_p2_eco = res.form_c?.project_section?.s4_p2_eco;
        this.formOOI.s4_p2_social = res.form_c?.project_section?.s4_p2_social;
        this.formOOI.s4_p3_result = res.form_c?.project_section?.s4_p3_result;
        this.formOOI.s4_p4_quantity =
          res.form_c?.project_section?.s4_p4_quantity;
        this.formOOI.s4_p4_quality = res.form_c?.project_section?.s4_p4_quality;
        this.formOOI.s4_p5_quantity =
          res.form_c?.project_section?.s4_p5_quantity;
        this.formOOI.s4_p5_quality = res.form_c?.project_section?.s4_p5_quality;
        this.formOOI.s4_p4_revenue = res.form_c?.project_section?.s4_p4_revenue;
        this.formOOI.s4_p4_revenue_desc =
          res.form_c?.project_section?.s4_p4_revenue_desc;
        this.formOOI.s4_p4_mgm_cost =
          res.form_c?.project_section?.s4_p4_mgm_cost;
        this.formOOI.s4_p4_mgm_cost_desc =
          res.form_c?.project_section?.s4_p4_mgm_cost_desc;
        this.formOOI.s4_p4_prod_cap =
          res.form_c?.project_section?.s4_p4_prod_cap;
        this.formOOI.s4_p4_prod_cap_desc =
          res.form_c?.project_section?.s4_p4_prod_cap_desc;
        this.formOOI.s4_p4_investment =
          res.form_c?.project_section?.s4_p4_investment;
        this.formOOI.s4_p4_investment_desc =
          res.form_c?.project_section?.s4_p4_investment_desc;
        this.formOOI.s4_p4_social_impact_eval =
          res.form_c?.project_section?.s4_p4_social_impact_eval;
        this.formOOI.s4_p4_social_impact_eval_desc =
          res.form_c?.project_section?.s4_p4_social_impact_eval_desc;
        this.formOOI.s4_p4_sci_tech_impact_eval =
          res.form_c?.project_section?.s4_p4_sci_tech_impact_eval;
        this.formOOI.s4_p4_sci_tech_impact_eval_desc =
          res.form_c?.project_section?.s4_p4_sci_tech_impact_eval_desc;
        this.formOOI.s4_p5_opinion = res.form_c?.project_section?.s4_p5_opinion;
        //
        this.formOOI.kpi_sub_values = res.form_c?.kpi_sub_values || [];
        this.formPlan = res.form_c?.project_section_plan || {};
        this.formPlan.s3_p4_final_day = res.form_c?.s3_p4_final_day;
        this.formPlan.s3_p4_progress_day = res.form_c?.s3_p4_progress_day;
        this.formPlan.s3_p4_progress_pct = res.form_c?.s3_p4_progress_pct;
        this.formPlan.s3_solution = res.form_c?.s3_solution;
        this.formPlan.s3_problem = res.form_c?.s3_problem;
        this.formPlan.s3_p3_ip_management = res.form_c?.s3_p3_ip_management;
        this.formPlan.s3_p3_problem = res.form_c?.s3_p3_problem;
        this.formPlan.s3_p3_solution = res.form_c?.s3_p3_solution;
        this.formPlan.s3_p3_interest = res.form_c?.s3_p3_interest;
        this.formPlan.budget_amount = res.form_c?.budget_amount;
        this.formPlan.job_delivery_details = res.form_c?.job_delivery_details || [];
        this.formAttachment = res.form_c?.attachments || [];

        if (
          this.masterData.form_c &&
          this.masterData.form_c.project_section?.s2_p4_prv_org_involved
        ) {
          let orgInvolved =
            this.masterData.form_c.project_section.s2_p4_prv_org_involved;
          if (typeof orgInvolved === "string") {
            try {
              orgInvolved = JSON.parse(orgInvolved);
              this.masterData.form_c.project_section.s2_p4_prv_org_involved =
                orgInvolved;
            } catch (e) {
              console.error("Could not parse orgInvolved:", e);
            }
          }
        }
      } else {
        this.onCancel();
      }
    },
    docTypeName() {
      if (
        this.masterData.form_c?.doc_type === "Progress" &&
        this.masterData.form_c?.progress_month > 0
      ) {
        return (
          "รายงานความก้าวหน้า " +
          this.masterData.form_c.progress_month.toString() +
          " เดือน"
        );
      } else if (this.masterData.form_c?.doc_type === "Final") {
        return "รายงานฉบับสมบูรณ์";
      }
      return "";
    },
    onCancel() {
      //clear formProject
      this.formProject = {};

      // back route
      let backRoute = "AvailablePlan";
      switch (this.userRole) {
        case "USP":
          if (this.isFinal) {
            // USP P/F
            backRoute = "ProgressReportList";
          } else {
            // USP S/I
            // no ID
            if (!this.$route.params.id) backRoute = "AvailablePlan";

            let status = this.masterData.form_c?.status;
            if (
              status === "Draft" ||
              status === "Submitted1" ||
              status === "Reject"
            ) {
              // Draft, Submitted1, Reject
              backRoute = "PlanOfferList";
            } else {
              // Inception, Submitted2, Approved, Completed
              backRoute = "AllocatedProjectList";
            }
          }
          break;

        case "RSP":
          if (this.isFinal) {
            // RSP P/F
            backRoute = "ProgressReportList";
          } else {
            // RSP S/I
            backRoute = "PlanOfferList";
          }
          break;
      }
      this.$router.push({ name: backRoute });
    },
    updateSubFormComponent() {
      this.f1_formKey += 1;
      this.f2_formKey += 1;
      this.f3_formKey += 1;
      this.f4_formKey += 1;
      this.f5_formKey += 1;
      this.f6_formKey += 1;
    },
    generateDynamicYearMonths() {
      const fiscalYear = this.masterData.project_accept_round?.plan?.main_project?.fiscal_year ||
                        this.masterData.main_project?.fiscal_year ||
                        new Date().getFullYear() + 543;

      let ym = new Date((fiscalYear - 544).toString() + "-10");
      const yearMonths = [];

      for (let i = 0; i < 12; i++) {
        yearMonths.push(ym.toISOString().substr(0, 7));
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }

      return yearMonths;
    },
    async uploadFile(file) {
      try {
        let formData = new FormData();
        formData.append("files[]", file);
        let payload = {
          files: formData,
        };
        let res = await this.$apiFire("Attachment/uploadFile", formData);
        if (res.length > 0) {
          return res[0];
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },

    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    // convertPDF() {
    //   const pdf = new jsPDF("p", "mm", "a4");
    //   let element = document.querySelector("#pdf");
    //
    //   // Desired DPI
    //   let dpi = 150;
    //
    //   // Calculate the scaling factor
    //   let scaleFactor = dpi / 96;
    //
    //   let toShow = document.getElementsByClassName('to-show')
    //
    //   //show toShow
    //   for (let i = 0; i < toShow.length; i++) {
    //     toShow[i].style.display = 'block';
    //     toShow[i].style.visibility = 'visible';
    //     toShow[i].style.height = 'auto';
    //   }
    //
    //
    //   html2canvas(element, { scale: scaleFactor })
    //       .then((canvas) => {
    //         let imgData = canvas.toDataURL('image/png');
    //
    //         // Calculate the ratio to fit the image within the dimensions of an A4 page
    //         let imgWidth = 210; // width of an A4 page in mm
    //         let pageHeight = 297;  // height of an A4 page in mm
    //         let imgHeight = canvas.height * imgWidth / canvas.width;
    //         let heightLeft = imgHeight;
    //         let marginTop = 20;
    //         let marginLeft = 15;
    //
    //         pdf.addImage(imgData, 'PNG', marginLeft, marginTop, imgWidth-(marginLeft*2), imgHeight-(marginLeft*2), undefined, 'FAST');
    //         heightLeft -= pageHeight-marginTop;
    //
    //         // add pages if the content overflows
    //         while (heightLeft >= 0) {
    //           marginTop = (heightLeft - imgHeight);
    //           pdf.addPage();
    //
    //           pdf.addImage(imgData, 'PNG', marginLeft, marginTop, imgWidth-(marginLeft*2), imgHeight-(marginLeft*2), undefined, 'FAST');
    //           heightLeft -= pageHeight;
    //         }
    //
    //         pdf.save(`html2canvas.pdf`);
    //
    //         //hide toShow
    //         for (let i = 0; i < toShow.length; i++) {
    //           toShow[i].style.display = 'none';
    //           toShow[i].style.visibility = 'hidden';
    //           toShow[i].style.height = '0';
    //         }
    //       })
    //       .catch(function (e) {
    //         this.updateSnackMessage(`Error at html2canvas : ${e} `);
    //       });
    //
    // },
    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

      //change document title
      document.title =
        "Form_C_" + this.userRole + "_" + this.plan_code + "_" + today;
      let toHide = document.getElementsByClassName("to-hide");
      let pdfPage = document.getElementById("pdf");
      let mainContent = document.getElementById("main");
      let titled = document.getElementsByClassName("titled");
      let toShow = document.getElementsByClassName("to-show");
      let noBoxShadow = document.getElementsByClassName("no-box-shadow");
      let s3p1 = document.getElementsByClassName("s3-p1");
      let s3p1h = document.getElementsByClassName("s3-p1-h");
      let indent_info = document.getElementsByClassName("indent-info");

      //remove all class name indent-info
      for (let i = 0; i < indent_info.length; i++) {
        indent_info[i].style.paddingLeft = "10px";
      }

      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      for (let i = 0; i < titled.length; i++) {
        titled[i].style.boxShadow = "none";

        //set box shadow to every child of titled
        let titledChild = titled[i].children;
        for (let j = 0; j < titledChild.length; j++) {
          titledChild[j].style.boxShadow = "none";
        }
      }

      //set no-box-shadow box-shadow to none
      for (let i = 0; i < noBoxShadow.length; i++) {
        noBoxShadow[i].style.boxShadow = "none";

        //set border
        noBoxShadow[i].style.border = "1px solid #F5F5F5";
      }

      //set s3p1 style scale 0.75
      let progress_month = this.masterData.form_c?.progress_month || 0;
      for (let i = 0; i < s3p1.length; i++) {
        s3p1[i].style.transform =
          progress_month <= 12
            ? "scale(0.75)"
            : progress_month === 18
            ? "scale(0.5)"
            : "scale(0.4)";
        s3p1[i].style.transformOrigin = "top left";
        s3p1[i].style.alignItems = "flex-start";

        //remove class overflow-x-auto
        s3p1[i].classList.remove("overflow-x-auto");
      }
      //set s3p1h style height 450px
      for (let i = 0; i < s3p1h.length; i++) {
        s3p1h[i].style.height = "550px";
      }

      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },
    autoField(currentStep, plan_code) {
      console.log("autoField masterData.form_c", this.masterData);
      if (currentStep == 2) {
        if (plan_code === "STI") {
          this.masterData.form_c.project_section.s2_p1_pm_name = "นายทดสอบ";
          this.masterData.form_c.project_section.s2_p1_pm_position =
            "นักบริหาร";
          this.masterData.form_c.project_section.s2_p1_pm_phone = "0954001111";
          this.masterData.form_c.project_section.s2_p1_pm_email =
            "test@mail.com";
          this.masterData.form_c.project_teams = [
            {
              s2_p1_name: "123",
              s2_p1_position: "นักบริหาร",
              s2_p1_phone: "0000",
              s2_p1_email: "test@mail.com",
            },
          ];
          this.masterData.form_c.project_section.s2_act_scope = "ทดสอบ";
          this.masterData.form_c.project_section.s2_principle = "ทดสอบ";
          this.masterData.form_c.project_section.s2_objective = "ทดสอบ";
          this.masterData.form_c.project_section.s2_focus_industry = "ทดสอบ";
          this.masterData.form_c.project_section.s2_target = "ทดสอบ";
          this.masterData.form_c.project_section.s2_past_work = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_concept = "ทดสอบ";
          this.masterData.form_c.project_section.s2_ready = "ทดสอบ";
          this.masterData.form_c.project_section.s2_qualify = "ทดสอบ";
          this.masterData.form_c.project_section.s2_criteria = "ทดสอบ";
          this.masterData.form_c.project_section.s2_guideline = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_scope = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_idea = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_process = "ทดสอบ";
          this.masterData.form_c.project_section.s2_finding = "ทดสอบ";
          this.masterData.form_c.project_section.s2_ent_select = "ทดสอบ";
          this.masterData.form_c.project_section.s2_original_ent = "ทดสอบ";
          this.masterData.form_c.project_section.s2_new_ent = "ทดสอบ";
          this.masterData.form_c.project_section.s2_nanny = "ทดสอบ";
          this.masterData.form_c.project_section.s2_expert = "ทดสอบ";
          this.masterData.form_c.project_section.s2_network = "ทดสอบ";
          this.masterData.form_c.project_section.s2_facility = "ทดสอบ";
          this.masterData.form_c.project_section.s2_service = "ทดสอบ";
          this.masterData.form_c.project_section.s2_operation = "ทดสอบ";
          this.masterData.form_c.project_section.s2_main_ads = "ทดสอบ";
          this.masterData.form_c.project_section.s2_main_continue = "ทดสอบ";
          this.masterData.form_c.project_section.s2_project_evaluate = "ทดสอบ";
          this.masterData.form_c.project_section.s2_performance = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_concept = "ทดสอบ";
          this.masterData.form_c.project_section.s2_ready = "ทดสอบ";
          this.masterData.form_c.project_section.s2_qualify = "ทดสอบ";
          this.masterData.form_c.project_section.s2_criteria = "ทดสอบ";
          this.masterData.form_c.project_section.s2_guideline = "ทดสอบ";
          this.masterData.form_c.project_section.s2_ads = "ทดสอบ";
          this.masterData.form_c.project_section.s2_select = "ทดสอบ";
          this.masterData.form_c.project_section.s2_action = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_uni = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_region = "ทดสอบ";
          this.masterData.form_c.project_section.s2_act_country = "ทดสอบ";
          this.masterData.form_c.project_section.s2_continue = "ทดสอบ";
          this.masterData.form_c.project_section.s2_p8_project_evaluate =
            "ทดสอบ";
          this.masterData.form_c.project_section.s2_operation = "ทดสอบ";
          this.masterData.form_c.project_section.s2_ads = "ทดสอบ";
          this.masterData.form_c.project_section.s2_continue = "ทดสอบ";
          this.masterData.form_c.project_section.s2_performance = "ทดสอบ";
          this.masterData.form_c.project_section.s2_finding = "ทดสอบ";
          this.masterData.form_c.project_section.s2_ent_select = "ทดสอบ";
          this.masterData.form_c.project_section.s2_original_ent = "ทดสอบ";
          this.masterData.form_c.project_section.s2_new_ent = "ทดสอบ";
          this.masterData.form_c.project_section.s2_nanny = "ทดสอบ";
          this.masterData.form_c.project_section.s2_expert = "ทดสอบ";
          this.masterData.form_c.project_section.s2_network = "ทดสอบ";
          this.masterData.form_c.project_section.s2_facility = "ทดสอบ";
          this.masterData.form_c.project_section.s2_service = "ทดสอบ";
          this.masterData.form_c.project_section.s2_operation = "ทดสอบ";
          this.masterData.form_c.project_section.s2_main_ads = "ทดสอบ";
          this.masterData.form_c.project_section.s2_main_continue = "ทดสอบ";
          this.masterData.form_c.project_section.s2_p9_project_evaluate =
            "ทดสอบ";
          this.masterData.form_c.project_section.s2_performance = "ทดสอบ";
          this.masterData.form_c.project_section.s2_rsp_procedure = "ทดสอบ";
          this.masterData.form_c.project_section.s2_rsp_ads = "ทดสอบ";
          this.masterData.form_c.project_section.s2_select_uni = "ทดสอบ";
          this.masterData.form_c.project_section.s2_model = "ทดสอบ";
          this.masterData.form_c.project_section.s2_action_plan = "ทดสอบ";
          this.masterData.form_c.project_section.s2_rsp_procedure = "ทดสอบ";
          this.masterData.form_c.project_section.s2_rsp_ads = "ทดสอบ";
          // this.masterData.form_c.project_section.s2_select_uni = "ทดสอบ";
          this.masterData.form_c.project_section.s2_competition_plan = "ทดสอบ";
          this.masterData.form_c.project_section.s2_competition_network =
            "ทดสอบ";
          this.masterData.form_c.project_section.s2_evaluate = "ทดสอบ";
          this.masterData.form_c.project_section.s2_benefit = "ทดสอบ";
        } else if (plan_code === "SP") {
          // ส่วนที่ 2: ข้อมูลโครงการ - Basic Fields
          this.masterData.form_c.project_section.principle = "ทดสอบ";
          this.masterData.form_c.project_section.objective = "ทดสอบ";
          this.masterData.form_c.project_section.demand = "ทดสอบ";
          this.masterData.form_c.project_section.marketing = "ทดสอบ";
          this.masterData.form_c.project_section.scope = "ทดสอบ";

          // Fields for non-final version (!isFinal)
          this.masterData.form_c.project_section.lab_ready = "ทดสอบ";
          this.masterData.form_c.project_section.tools_enhance = "ทดสอบ";
          this.masterData.form_c.project_section.convenient = "ทดสอบ";
          this.masterData.form_c.project_section.improve_officer = "ทดสอบ";
          this.masterData.form_c.project_section.reference = "ทดสอบ";
          this.masterData.form_c.project_section.past_improvement = "ทดสอบ";
          this.masterData.form_c.project_section.past_management = "ทดสอบ";
          this.masterData.form_c.project_section.past_performance = "ทดสอบ";

          // Fields for final version (isFinal)
          this.masterData.form_c.project_section.initiative_idea = "ทดสอบ";
          this.masterData.form_c.project_section.industrial_target = "ทดสอบ";
          this.masterData.form_c.project_section.target = "ทดสอบ";

          // การพัฒนาศักยภาพและให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม (pd_*)
          this.masterData.form_c.project_section.pd_overview = "ทดสอบ";
          this.masterData.form_c.project_section.pd_needs = "ทดสอบ";
          this.masterData.form_c.project_section.pd_marketing = "ทดสอบ";
          this.masterData.form_c.project_section.pd_readiness = "ทดสอบ";
          this.masterData.form_c.project_section.pd_organization = "ทดสอบ";
          this.masterData.form_c.project_section.pd_facilities = "ทดสอบ";
          this.masterData.form_c.project_section.pd_service_process = "ทดสอบ";
          this.masterData.form_c.project_section.pd_connection = "ทดสอบ";
          this.masterData.form_c.project_section.pd_experts = "ทดสอบ";
          this.masterData.form_c.project_section.pd_performance = "ทดสอบ";
          this.masterData.form_c.project_section.pd_kpi = "ทดสอบ";
          this.masterData.form_c.project_section.pd_results = "ทดสอบ";

          // บริการออกแบบนวัตกรรม (ds_*)
          this.masterData.form_c.project_section.ds_overview = "ทดสอบ";
          this.masterData.form_c.project_section.ds_needs = "ทดสอบ";
          this.masterData.form_c.project_section.ds_marketing = "ทดสอบ";
          this.masterData.form_c.project_section.ds_readiness = "ทดสอบ";
          this.masterData.form_c.project_section.ds_organization = "ทดสอบ";
          this.masterData.form_c.project_section.ds_facilities = "ทดสอบ";
          this.masterData.form_c.project_section.ds_service_process = "ทดสอบ";
          this.masterData.form_c.project_section.ds_connection = "ทดสอบ";
          this.masterData.form_c.project_section.ds_experts = "ทดสอบ";
          this.masterData.form_c.project_section.ds_performance = "ทดสอบ";
          this.masterData.form_c.project_section.ds_kpi = "ทดสอบ";
          this.masterData.form_c.project_section.ds_results = "ทดสอบ";

          // การบริหารจัดการทรัพย์สินทางปัญญาแก่ภาคอุตสาหกรรม (ip_*)
          this.masterData.form_c.project_section.ip_overview = "ทดสอบ";
          this.masterData.form_c.project_section.ip_needs = "ทดสอบ";
          this.masterData.form_c.project_section.ip_marketing = "ทดสอบ";
          this.masterData.form_c.project_section.ip_readiness = "ทดสอบ";
          this.masterData.form_c.project_section.ip_organization = "ทดสอบ";
          this.masterData.form_c.project_section.ip_facilities = "ทดสอบ";
          this.masterData.form_c.project_section.ip_service_process = "ทดสอบ";
          this.masterData.form_c.project_section.ip_connection = "ทดสอบ";
          this.masterData.form_c.project_section.ip_experts = "ทดสอบ";
          this.masterData.form_c.project_section.ip_performance = "ทดสอบ";
          this.masterData.form_c.project_section.ip_kpi = "ทดสอบ";
          this.masterData.form_c.project_section.ip_results = "ทดสอบ";

          // ฐานข้อมูลโครงสร้างพื้นฐานภาครัฐด้านวิทยาศาสตร์และเทคโนโลยี (stdb_*)
          this.masterData.form_c.project_section.stdb_overview = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_needs = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_marketing = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_readiness = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_organization = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_facilities = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_service_process = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_connection = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_experts = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_performance = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_kpi = "ทดสอบ";
          this.masterData.form_c.project_section.stdb_results = "ทดสอบ";

          // ความร่วมมืออุตสาหกรรม (ic_*)
          this.masterData.form_c.project_section.ic_overview = "ทดสอบ";
          this.masterData.form_c.project_section.ic_needs = "ทดสอบ";
          this.masterData.form_c.project_section.ic_marketing = "ทดสอบ";
          this.masterData.form_c.project_section.ic_readiness = "ทดสอบ";
          this.masterData.form_c.project_section.ic_organization = "ทดสอบ";
          this.masterData.form_c.project_section.ic_facilities = "ทดสอบ";
          this.masterData.form_c.project_section.ic_service_process = "ทดสอบ";
          this.masterData.form_c.project_section.ic_connection = "ทดสอบ";
          this.masterData.form_c.project_section.ic_experts = "ทดสอบ";
          this.masterData.form_c.project_section.ic_performance = "ทดสอบ";
          this.masterData.form_c.project_section.ic_kpi = "ทดสอบ";
          this.masterData.form_c.project_section.ic_results = "ทดสอบ";

          // ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ (ref_*)
          this.masterData.form_c.project_section.ref_overview = "ทดสอบ";
          this.masterData.form_c.project_section.ref_needs = "ทดสอบ";
          this.masterData.form_c.project_section.ref_marketing = "ทดสอบ";
          this.masterData.form_c.project_section.ref_readiness = "ทดสอบ";
          this.masterData.form_c.project_section.ref_organization = "ทดสอบ";
          this.masterData.form_c.project_section.ref_facilities = "ทดสอบ";
          this.masterData.form_c.project_section.ref_service_process = "ทดสอบ";
          this.masterData.form_c.project_section.ref_connection = "ทดสอบ";
          this.masterData.form_c.project_section.ref_experts = "ทดสอบ";
          this.masterData.form_c.project_section.ref_performance = "ทดสอบ";
          this.masterData.form_c.project_section.ref_kpi = "ทดสอบ";
          this.masterData.form_c.project_section.ref_results = "ทดสอบ";
        } else if (plan_code === "IRTC") {
          this.masterData.form_c.project_section.s2_p1_name = "นายทดสอบ";
          this.masterData.form_c.project_section.s2_p1_position = "นักบริหาร";
          this.masterData.form_c.project_section.s2_p1_dep =
            "สำนักนายกรัฐมนตรี";
          this.masterData.form_c.project_section.s2_p1_org = "ทดสอบ สังกัด";
          this.masterData.form_c.project_section.s2_p1_addr = "ทดสอบ ที่อยู่";
          this.masterData.form_c.project_section.s2_p1_phone = "0812345678";
          this.masterData.form_c.project_section.s2_p1_email = "test@email.com";
          this.masterData.form_c.project_section.s2_p1_expertise =
            "ทดสอบ ความเชี่ยวชาญ";
          this.masterData.form_c.project_section.s2_p1_resp =
            "ทดสอบ สัดส่วนการทำงาน";
          this.masterData.form_c.project_section.s2_p1_resp_hrs =
            "ทดสอบ ชั่วโมงการทำงาน";

          // คณะผู้เชี่ยวชาญ (Expert Team Members)
          this.masterData.form_c.project_teams = [
            {
              s2_p1_name: "ทดสอบ คณะที่1",
              s2_p1_position: "นักบริหาร",
              s2_p1_dep: "สำนักนายกรัฐมนตรี",
              s2_p1_org: "ทดสอบ สังกัด 1",
              s2_p1_addr: "ทดสอบ ที่อยู่ 1",
              s2_p1_phone: "0823456789",
              s2_p1_email: "test1@email.com",
              s2_p1_expertise: "ทดสอบ ความเชี่ยวชาญ 1",
              s2_p1_resp: "ทดสอบ สัดส่วนการทำงาน 1",
              s2_p1_resp_hrs: "ทดสอบ ชั่วโมงการทำงาน 1",
            },
            {
              s2_p1_name: "ทดสอบ คณะที่2",
              s2_p1_position: "นักบริหาร",
              s2_p1_dep: "สำนักนายกรัฐมนตรี",
              s2_p1_org: "ทดสอบ สังกัด 2",
              s2_p1_addr: "ทดสอบ ที่อยู่ 2",
              s2_p1_phone: "0834567890",
              s2_p1_email: "test2@email.com",
              s2_p1_expertise: "ทดสอบ ความเชี่ยวชาญ 2",
              s2_p1_resp: "ทดสอบ สัดส่วนการทำงาน 2",
              s2_p1_resp_hrs: "ทดสอบ ชั่วโมงการทำงาน 2",
            },
          ];

          // Section 2: ผู้รับผิดชอบโครงการ (Project Manager) - ภาคเอกชน
          this.masterData.form_c.project_section.s2_p2_pm_name =
            "ทดสอบ ผู้รับผิดชอบโครงการ";
          this.masterData.form_c.project_section.s2_p2_pm_position =
            "นักบริหาร";
          this.masterData.form_c.project_section.s2_p2_pm_phone = "0845678901";
          this.masterData.form_c.project_section.s2_p2_pm_email = "pm@test.com";

          this.masterData.form_c.project_section.s2_p2_proj_coord_name =
            "ทดสอบ ผู้ประสานงานโครงการ";
          this.masterData.form_c.project_section.s2_p2_proj_coord_position =
            "นักบริหาร";
          this.masterData.form_c.project_section.s2_p2_proj_coord_phone =
            "0856789012";
          this.masterData.form_c.project_section.s2_p2_proj_coord_email =
            "coord@test.com";

          // Section 3: ข้อมูลภาคเอกชนที่เข้าร่วมโครงการ
          this.masterData.form_c.project_section.s2_p3_prv_org_name =
            "ทดสอบ ชื่อนิติบุคคล/กิจการ";
          this.masterData.form_c.project_section.s2_p3_prv_org_address =
            "ทดสอบ ที่อยู่องค์กร";
          this.masterData.form_c.project_section.s2_p3_addr_pid =
            "กรุงเทพมหานคร";
          this.masterData.form_c.project_section.s2_p3_addr_did = "บางรัก";
          this.masterData.form_c.project_section.s2_p3_addr_sdid = "สีลม";
          this.masterData.form_c.project_section.s2_p3_prv_org_phone =
            "0212345678";
          this.masterData.form_c.project_section.s2_p3_prv_org_email =
            "org@test.com";
          this.masterData.form_c.project_section.s2_p3_prv_org_type =
            "ทดสอบ รูปแบบของธุรกิจ/ลักษณะกิจการ";
          this.masterData.form_c.project_section.s2_p3_prv_org_trend =
            "ทดสอบ แนวโน้มการเป็นผู้เช่าพื้นที่ในอุทยานวิทยาศาสตร์ภูมิภาค";

          // Section 4: กลุ่มอุตสาหกรรมที่เกี่ยวข้อง
          this.masterData.form_c.project_section.s2_p4_prv_org_involved =
            "กลุ่มอุตสาหกรรมอาหาร";
          this.masterData.form_c.project_section.s2_p4_prv_org_other =
            "ทดสอบ อุตสาหกรรมอื่นๆ";

          // Section 5: หลักการและเหตุผล
          this.masterData.form_c.project_section.s2_p11_principle =
            "<p>ทดสอบ หลักการและเหตุผล</p>";

          // Section 6: วัตถุประสงค์
          this.masterData.form_c.project_section.s2_p12_objective =
            "ทดสอบ วัตถุประสงค์";

          // Section 7: ระบุปัญหาหรือความต้องการของภาคเอกชน
          this.masterData.form_c.project_section.s2_p6_prv_org_issue_desc =
            "<p>ทดสอบ ปัญหาหรือความต้องการของภาคเอกชน</p>";

          // Section 8: กิจการของภาคเอกชน ได้รับการแก้ไขปัญหาด้านใด
          this.masterData.form_c.project_section.s2_p5_prv_org_impr_product_quality =
            "<p>ทดสอบ พัฒนาคุณภาพสินค้าให้ได้มาตรฐาน</p>";
          this.masterData.form_c.project_section.s2_p5_prv_org_impr_process_issue =
            "<p>ทดสอบ การแก้ไขปัญหาของกระบวนการผลิต</p>";
          this.masterData.form_c.project_section.s2_p5_prv_org_impr_process_eff =
            "<p>ทดสอบ การปรับปรุงประสิทธิภาพกระบวนการผลิต</p>";
          this.masterData.form_c.project_section.s2_p5_prv_org_impr_new_product =
            "<p>ทดสอบ การพัฒนาผลิตภัณฑ์ใหม่</p>";

          // Section 9: เทคโนโลยี นวัตกรรม และการพัฒนา
          this.masterData.form_c.project_section.s2_p7_inno_desc =
            "<p>ทดสอบ เทคโนโลยี นวัตกรรม และการพัฒนา</p>";

          // Section 10: ศักยภาพและความพร้อมในการดำเนินโครงการของภาคเอกชน
          this.masterData.form_c.project_section.s2_p8_prv_org_project_readiness =
            "<p>ทดสอบ ความรู้พื้นฐานด้านเทคโนโลยี</p>";
          this.masterData.form_c.project_section.s2_p8_prv_org_rnd_readiness =
            "<p>ทดสอบ ความพร้อมด้านอุปกรณ์ เครื่องมือ</p>";
          this.masterData.form_c.project_section.s2_p8_prv_org_financial_readiness =
            "<p>ทดสอบ ความพร้อมด้านการเงิน</p>";
          this.masterData.form_c.project_section.s2_p8_prv_org_mgmt_readiness =
            "<p>ทดสอบ การบริหารจัดการองค์กรและบุคลากร</p>";

          // Section 11: ศักยภาพและความพร้อมของอุทยานวิทยาศาสตร์ภูมิภาค
          this.masterData.form_c.project_section.s2_p9_personnel_expertise =
            "<p>ทดสอบ ความพร้อมของบุคลากรและผู้เชี่ยวชาญ</p>";
          this.masterData.form_c.project_section.s2_p9_lab_eqt_readiness =
            "<p>ทดสอบ ความพร้อมของห้องปฏิบัติการ</p>";
          this.masterData.form_c.project_section.s2_p9_knowledge_readiness =
            "<p>ทดสอบ องค์ความรู้พื้นฐาน</p>";

          // Section 12: ขั้นตอนและขอบเขตการดำเนินโครงการ
          this.masterData.form_c.project_section.s2_p10_project_scope_detail =
            "<p>ทดสอบ ขั้นตอนและขอบเขตการดำเนินโครงการ</p>";

          // Final Report Sections (for isFinal = true)
          this.masterData.form_c.project_section.s2_source =
            "<p>ทดสอบ ที่มาและความสำคัญ</p>";
          this.masterData.form_c.project_section.s2_industry_type =
            "<p>ทดสอบ </p>";
          this.masterData.form_c.project_section.s2_apply_type =
            "พัฒนาผลิตภัณฑ์ใหม่";
          this.masterData.form_c.project_section.s2_overall_result = "ทดสอบ";
          this.masterData.form_c.project_section.s2_summary_operation_detail =
            "ทดสอบ";
          this.masterData.form_c.project_section.s2_interest = "IRTC";
        } else if (plan_code === "CR") {
          // Section 1: ข้อมูลหัวหน้าโครงการและคณะ
          this.masterData.form_c.project_section.s2_p1_name =
            "นายทดสอบ หัวหน้าโครงการ";
          this.masterData.form_c.project_section.s2_p1_position = "นักบริหาร";
          this.masterData.form_c.project_section.s2_p1_dep =
            "สำนักนายกรัฐมนตรี";
          this.masterData.form_c.project_section.s2_p1_org = "ทดสอบ สังกัด";
          this.masterData.form_c.project_section.s2_p1_addr =
            "ทดสอบ ที่อยู่หัวหน้าโครงการ";
          this.masterData.form_c.project_section.s2_p1_phone = "0812345678";
          this.masterData.form_c.project_section.s2_p1_email = "head@test.com";
          this.masterData.form_c.project_section.s2_p1_expertise =
            "ทดสอบ ความเชี่ยวชาญหัวหน้าโครงการ";
          this.masterData.form_c.project_section.s2_p1_resp =
            "ทดสอบ สัดส่วนการทำงาน";
          this.masterData.form_c.project_section.s2_p1_resp_hrs =
            "ทดสอบ ชั่วโมงการทำงาน";

          // คณะทีมหัวหน้าโครงการ
          this.masterData.form_c.project_head_team = [
            {
              team_type: "ข้อมูลหัวหน้าโครงการและคณะ",
              s2_p1_name: "ทดสอบ คณะที่1",
              s2_p1_position: "นักวิชาการ",
              s2_p1_dep: "สำนักนายกรัฐมนตรี",
              s2_p1_org: "ทดสอบ สังกัด คณะ1",
              s2_p1_addr: "ทดสอบ ที่อยู่ คณะ1",
              s2_p1_phone: "0823456789",
              s2_p1_email: "team1@test.com",
              s2_p1_expertise: "ทดสอบ ความเชี่ยวชาญ คณะ1",
              s2_p1_resp: "ทดสอบ สัดส่วนการทำงาน คณะ1",
              s2_p1_resp_hrs: "ทดสอบ ชั่วโมงการทำงาน คณะ1",
            },
          ];

          // Section 2: ผู้รับผิดชอบโครงการ (Project Manager) - ภาคเอกชน
          this.masterData.form_c.project_section.s2_p2_name =
            "นายทดสอบ ผู้รับผิดชอบโครงการ";
          this.masterData.form_c.project_section.s2_p2_position =
            "ผู้จัดการโครงการ";
          this.masterData.form_c.project_section.s2_p2_dep =
            "สำนักนายกรัฐมนตรี";
          this.masterData.form_c.project_section.s2_p2_org =
            "ทดสอบ สังกัด ผู้รับผิดชอบ";
          this.masterData.form_c.project_section.s2_p2_addr =
            "ทดสอบ ที่อยู่ ผู้รับผิดชอบโครงการ";
          this.masterData.form_c.project_section.s2_p2_phone = "0834567890";
          this.masterData.form_c.project_section.s2_p2_email =
            "manager@test.com";
          this.masterData.form_c.project_section.s2_p2_expertise =
            "ทดสอบ ความเชี่ยวชาญผู้รับผิดชอบ";
          this.masterData.form_c.project_section.s2_p2_resp =
            "ทดสอบ สัดส่วนการทำงานผู้รับผิดชอบ";
          this.masterData.form_c.project_section.s2_p2_resp_hrs =
            "ทดสอบ ชั่วโมงการทำงานผู้รับผิดชอบ";

          // ทีมผู้รับผิดชอบโครงการ
          this.masterData.form_c.project_manager_team = [
            {
              team_type: "ผู้รับผิดชอบโครงการ",
              s2_p1_name: "ทดสอบ ผู้รับผิดชอบ ที่2",
              s2_p1_position: "นักวิเคราะห์",
              s2_p1_dep: "สำนักนายกรัฐมนตรี",
              s2_p1_org: "ทดสอบ สังกัด ผู้รับผิดชอบ2",
              s2_p1_addr: "ทดสอบ ที่อยู่ ผู้รับผิดชอบ2",
              s2_p1_phone: "0845678901",
              s2_p1_email: "manager2@test.com",
              s2_p1_expertise: "ทดสอบ ความเชี่ยวชาญผู้รับผิดชอบ2",
              s2_p1_resp: "ทดสอบ สัดส่วนการทำงานผู้รับผิดชอบ2",
              s2_p1_resp_hrs: "ทดสอบ ชั่วโมงการทำงานผู้รับผิดชอบ2",
            },
          ];

          // Section 3: ผู้รับประสานงาน
          this.masterData.form_c.project_section.s2_pc_name =
            "นายทดสอบ ผู้ประสานงาน";
          this.masterData.form_c.project_section.s2_pc_position =
            "เจ้าหน้าที่ประสานงาน";
          this.masterData.form_c.project_section.s2_pc_phone = "0856789012";
          this.masterData.form_c.project_section.s2_pc_email =
            "coordinator@test.com";
          this.masterData.form_c.project_section.s2_pc_dep =
            "สำนักนายกรัฐมนตรี";
          this.masterData.form_c.project_section.s2_pc_addr =
            "ทดสอบ ที่อยู่ผู้ประสานงาน";

          // ทีมผู้ประสานงาน
          this.masterData.form_c.project_coordinate_team = [
            {
              team_type: "ผู้รับประสานงาน",
              s2_p1_name: "ทดสอบ ผู้ประสานงาน ที่2",
              s2_p1_position: "ผู้ช่วยประสานงาน",
              s2_p1_dep: "สำนักนายกรัฐมนตรี",
              s2_p1_phone: "0867890123",
              s2_p1_email: "coord2@test.com",
              s2_p1_addr: "ทดสอบ ที่อยู่ผู้ประสานงาน2",
            },
          ];

          // Section 4: ข้อมูลภาคเอกชนที่เข้าร่วมทำวิจัยและพัฒนา
          this.masterData.form_c.project_section.s2_p3_prv_org_name =
            "บริษัท ทดสอบ วิจัยและพัฒนา จำกัด";
          this.masterData.form_c.project_section.s2_p3_prv_org_address =
            "ทดสอบ ที่อยู่บริษัท เลขที่ 123 ถนนทดสอบ";
          this.masterData.form_c.project_section.s2_p3_prv_org_phone =
            "0212345678";
          this.masterData.form_c.project_section.s2_p3_prv_org_email =
            "company@test.com";
          this.masterData.form_c.project_section.s2_p3_prv_org_type =
            "<p>ทดสอบ รูปแบบของธุรกิจ/ลักษณะกิจการ - บริษัทที่ดำเนินธุรกิจด้านวิจัยและพัฒนาเทคโนโลยี</p>";
          this.masterData.form_c.project_section.s2_p3_prv_org_prod_design =
            "<p>ทดสอบ รูปแบบผลิตภัณฑ์ - ผลิตภัณฑ์นวัตกรรมใหม่ที่มีความโดดเด่นและแตกต่างจากตลาด</p>";
          this.masterData.form_c.project_section.s2_p3_prv_org_ready =
            "<p>ทดสอบ ความพร้อมของเอกชนในการร่วมวิจัยและพัฒนา - มีความพร้อมด้านบุคลากร เครื่องมือ และงบประมาณ</p>";
          this.masterData.form_c.project_section.s2_p3_prv_org_potent =
            "<p>ทดสอบ ศักยภาพของภาคเอกชนในการนำเทคโนโลยีไปต่อยอดทางธุรกิจ - มีศักยภาพสูงในการพัฒนาเป็นผลิตภัณฑ์เชิงพาณิชย์</p>";
          this.masterData.form_c.project_section.s2_p3_prv_org_trend =
            "ทดสอบ แนวโน้มที่เอกชนจะนำงานวิจัยใช้ในการพัฒนาศักยภาพทางธุรกิจหรือเข้าร่วม Platform อื่นๆ";

          // Section 5: กิจการของภาคเอกชนที่เข้าร่วมโครงการมีความเกี่ยวข้องในกลุ่มอุตสาหกรรม
          this.masterData.form_c.project_section.s2_p4_prv_org_involved = [
            "กลุ่มอุตสาหกรรมอาหาร",
            "กลุ่มอุตสาหกรรมด้านเทคโนโลยีชีวภาพ",
          ];
          this.masterData.form_c.project_section.s2_p4_prv_org_other =
            "ทดสอบ อุตสาหกรรมอื่นๆ ที่เกี่ยวข้อง";

          // Section 6: ที่มาและความสำคัญ
          this.masterData.form_c.project_section.s2_p7_source =
            "<p>ทดสอบ ที่มาและความสำคัญของโครงการวิจัยร่วม - โครงการนี้เกิดขึ้นจากความต้องการพัฒนาเทคโนโลยีใหม่</p>";

          // Section 7: วัตถุประสงค์
          this.masterData.form_c.project_section.s2_p8_objective =
            "<p>ทดสอบ วัตถุประสงค์ของโครงการ<br>1. เพื่อพัฒนาเทคโนโลยีใหม่<br>2. เพื่อเสริมสร้างความร่วมมือระหว่างภาคการศึกษาและเอกชน<br>3. เพื่อสร้างนวัตกรรมที่สามารถนำไปใช้ประโยชน์ได้จริง</p>";

          // Section 8: ศักยภาพและความพร้อมในการดำเนินโครงการ (for !isFinal)
          this.masterData.form_c.project_section.s2_p5_intensity =
            "<p>ทดสอบ ความเข้มข้นของการใช้ผลงานวิจัย ต้นแบบ ที่มีผลพิสูจน์ในระดับห้องปฏิบัติการ - มีผลงานวิจัยพื้นฐานที่พร้อมต่อยอด</p>";
          this.masterData.form_c.project_section.s2_p5_lab_readiness =
            "<p>ทดสอบ ความพร้อมของห้องปฏิบัติการ เครื่องมืออุปกรณ์ทางวิทยาศาสตร์และสิ่งอำนวยความสะดวก</p>";
          this.masterData.form_c.project_section.s2_p5_collab_exp =
            "<p>ทดสอบ ประสบการณ์การทำงานร่วมกับภาคอุตสาหกรรมของทีมวิจัยของโครงการ</p>";
          this.masterData.form_c.project_section.s2_p5_tech_involved =
            "<p>ทดสอบ เทคโนโลยีที่เกี่ยวข้องในโครงการมีศักยภาพในการนำมาพัฒนาสู่เชิงพาณิชย์</p>";
          this.masterData.form_c.project_section.s2_p5_project_result =
            "<p>ทดสอบ ผลลัพธ์ของโครงการ เช่น เกิดผลิตภัณฑ์ใหม่ที่มีมูลค่าเพิ่มสูง</p>";
          this.masterData.form_c.project_section.s2_p5_reference =
            "<p>ทดสอบ เอกสารอ้างอิง หรือ ข้อมูล ที่แสดงถึงความสำเร็จของงานวิจัยที่ได้ดำเนินก่อนหน้านี้</p>";

          // Section 9: ขั้นตอนและขอบเขตการดำเนินโครงการ
          this.masterData.form_c.project_section.s2_p6_project_scope =
            "<p>ทดสอบ ขั้นตอนและขอบเขตการดำเนินโครงการ<br>ขั้นตอนที่ 1: การศึกษาและออกแบบ<br>ขั้นตอนที่ 2: การทดลองและพัฒนา<br>ขั้นตอนที่ 3: การทดสอบและปรับปรุง</p>";

          // Final Report Section (for isFinal = true)
          this.masterData.form_c.project_section.s2_result =
            "<p>ทดสอบ ผลการดำเนินงาน - โครงการได้ดำเนินการตามแผนที่กำหนดไว้และได้ผลลัพธ์ที่น่าพอใจ</p>";
        }
      } else if (currentStep == 3) {
        console.log("Set Step 3 Data");
        if (!this.masterData.form_c.project_section) {
          this.masterData.form_c.project_section = {};
        }

        if (plan_code === "IRTC") {
          // แผนการดำเนินงาน (Project based management)
          const dynamicMonths = this.generateDynamicYearMonths();
          this.masterData.form_c.project_section_plan = {
            project_plan_p1: [
              {
                p1_activity_name: "ทดสอบ การศึกษาและวิเคราะห์",
                p1_wf: "0.50",
                project_section_plan_month: [
                  {
                    year_month: dynamicMonths[0],
                    month_value: "30.00",
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[1],
                    month_value: "60.00",
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[2],
                    month_value: "100.00",
                    actual_month_value: null,
                  },
                  ...dynamicMonths.slice(3).map((year_month) => ({
                    year_month,
                    month_value: null,
                    actual_month_value: null,
                  })),
                ],
              },
              {
                p1_activity_name: "ทดสอบ การพัฒนาต้นแบบ",
                p1_wf: "0.50",
                project_section_plan_month: [
                  {
                    year_month: dynamicMonths[0],
                    month_value: null,
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[1],
                    month_value: "40.00",
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[2],
                    month_value: "100.00",
                    actual_month_value: null,
                  },
                  ...dynamicMonths.slice(3).map((year_month) => ({
                    year_month,
                    month_value: null,
                    actual_month_value: null,
                  })),
                ],
              },
            ],

            // แผนการใช้จ่าย
            project_section_plan_p1_budget: Array(12)
              .fill()
              .map((_, i) => {
                const budgets = [
                  "100000.00",
                  "150000.00",
                  "80000.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                ];
                const rates = [
                  "30.30",
                  "75.76",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                ];
                const useRates = [
                  "28.00",
                  "70.00",
                  "95.00",
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                ];

                return {
                  year_month:
                    i < 3
                      ? `2024-${10 + i}`
                      : `2025-${String(i - 2).padStart(2, "0")}`,
                  plan_budget: budgets[i],
                  plan_budget_rate: rates[i],
                  use_budget_rate: useRates[i],
                };
              }),

            // งบประมาณรายละเอียด
            project_section_budget: [
              {
                budget_name: "ทดสอบ ค่าตอบแทน",
                budget_detail: "ทดสอบ รายละเอียดค่าตอบแทน",
                budget_in_kind: 100000.0,
                budget_in_cash: 150000.0,
                budget_sci_park: 80000.0,
                budget_sum: 330000.0,
              },
            ],
          };

          // ปัญหาและอุปสรรคจากการดำเนินงาน (for isFinal)
          this.masterData.form_c.project_section.s3_problem =
            "ทดสอบ ปัญหาและอุปสรรค";

          // แนวทางในการแก้ไขปัญหา (for isFinal)
          this.masterData.form_c.project_section.s3_solution =
            "ทดสอบ แนวทางแก้ไขปัญหา";

          // รายละเอียดการส่งมอบงาน
          this.masterData.form_c.job_delivery_details = [
            {
              installment: "1",
              installment_date: "30",
              installment_percent: "50",
              installment_detail: "ทดสอบ รายละเอียดการส่งมอบงาน งวดที่ 1",
            },
            {
              installment: "2",
              installment_date: "90",
              installment_percent: "50",
              installment_detail: "ทดสอบ รายละเอียดการส่งมอบงาน งวดที่ 2",
            },
          ];
        } else if (plan_code === "CR") {
          // แผนการดำเนินงาน (Project based management)
          const dynamicMonths = this.generateDynamicYearMonths();
          this.masterData.form_c.project_section_plan = {
            project_plan_p1: [
              {
                p1_activity_name: "ทดสอบ การวิจัยและพัฒนา",
                p1_wf: "1.00",
                project_section_plan_month: [
                  {
                    year_month: dynamicMonths[0],
                    month_value: "25.00",
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[1],
                    month_value: "50.00",
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[2],
                    month_value: "100.00",
                    actual_month_value: null,
                  },
                  ...dynamicMonths.slice(3).map((year_month) => ({
                    year_month,
                    month_value: null,
                    actual_month_value: null,
                  })),
                ],
              },
            ],

            // แผนการใช้จ่าย
            project_section_plan_p1_budget: Array(12)
              .fill()
              .map((_, i) => {
                const budgets = [
                  "80000.00",
                  "120000.00",
                  "100000.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                ];
                const rates = [
                  "26.67",
                  "66.67",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                ];
                const useRates = [
                  "25.00",
                  "60.00",
                  "90.00",
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                ];

                return {
                  year_month: dynamicMonths[i],
                  plan_budget: budgets[i],
                  plan_budget_rate: rates[i],
                  use_budget_rate: useRates[i],
                };
              }),

            // งบประมาณรายละเอียด
            project_section_budget: [
              {
                budget_name: "ทดสอบ ค่าใช้จ่าย",
                budget_detail: "ทดสอบ รายละเอียดค่าใช้จ่าย",
                budget_in_kind: 120000.0,
                budget_in_cash: 100000.0,
                budget_sci_park: 80000.0,
                budget_sum: 300000.0,
              },
            ],
          };

          // การจัดการทรัพย์สินทางปัญญา
          this.masterData.form_c.project_section.s3_p3_ip_management =
            "<p>ทดสอบ การจัดการทรัพย์สินทางปัญญา</p>";

          // ปัญหาและอุปสรรคจากการดำเนินงาน (for isFinal)
          this.masterData.form_c.project_section.s3_p3_problem =
            "<p>ทดสอบ ปัญหาและอุปสรรค</p>";

          // แนวทางในการแก้ไขปัญหา (for isFinal)
          this.masterData.form_c.project_section.s3_p3_solution =
            "<p>ทดสอบ แนวทางแก้ไขปัญหา</p>";

          // ความสนใจในการใช้บริการอื่นๆของอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต (for isFinal)
          this.masterData.form_c.project_section.s3_p3_interest = [
            "Service Platform",
          ];

          // รายละเอียดการส่งมอบงาน
          this.masterData.form_c.job_delivery_details = [
            {
              installment: "1",
              installment_date: "30",
              installment_percent: "50",
              installment_detail: "ทดสอบ รายละเอียดการส่งมอบงาน",
            },
          ];
        } else {
          console.log("else");
          const dynamicMonths = this.generateDynamicYearMonths();
          this.masterData.form_c.project_section_plan = {
            project_plan_p1: [
              {
                p1_activity_name: "ทดสอบ การศึกษาและวิเคราะห์",
                p1_wf: "0.50",
                project_section_plan_month: [
                  {
                    year_month: dynamicMonths[0],
                    month_value: "30.00",
                  },
                  {
                    year_month: dynamicMonths[1],
                    month_value: "60.00",
                  },
                  {
                    year_month: dynamicMonths[2],
                    month_value: "100.00",
                  },
                  ...dynamicMonths.slice(3).map((year_month) => ({
                    year_month,
                    month_value: null,
                  })),
                ],
              },
              {
                p1_activity_name: "ทดสอบ การพัฒนาต้นแบบ",
                p1_wf: "0.50",
                project_section_plan_month: [
                  {
                    year_month: dynamicMonths[0],
                    month_value: null,
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[1],
                    month_value: "40.00",
                    actual_month_value: null,
                  },
                  {
                    year_month: dynamicMonths[2],
                    month_value: "100.00",
                    actual_month_value: null,
                  },
                  ...dynamicMonths.slice(3).map((year_month) => ({
                    year_month,
                    month_value: null,
                    actual_month_value: null,
                  })),
                ],
              },
            ],

            // แผนการใช้จ่าย
            project_section_plan_p1_budget: Array(12)
              .fill()
              .map((_, i) => {
                const budgets = [
                  "100000.00",
                  "150000.00",
                  "80000.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                  "0.00",
                ];
                const rates = [
                  "30.30",
                  "75.76",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                  "100.00",
                ];
                const useRates = [
                  "28.00",
                  "70.00",
                  "95.00",
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                ];

                return {
                  year_month:
                    i < 3
                      ? `2024-${10 + i}`
                      : `2025-${String(i - 2).padStart(2, "0")}`,
                  plan_budget: budgets[i],
                  plan_budget_rate: rates[i],
                  use_budget_rate: useRates[i],
                };
              }),

            // งบประมาณรายละเอียด
            project_section_budget: [
              {
                budget_name: "ทดสอบ ค่าตอบแทน",
                budget_detail: "ทดสอบ รายละเอียดค่าตอบแทน",
                budget_in_kind: 100000.0,
                budget_in_cash: 150000.0,
                budget_sci_park: 80000.0,
                budget_sum: 330000.0,
              },
            ],
          };
        }

        console.log(
          "this.masterData.form_c.project_section_plan",
          this.masterData.form_c.project_section_plan
        );
      } else if (currentStep == 4) {
        if (plan_code === "STI") {
          // ผลลัพธ์ที่ได้จากโครงการ (Outcome)
          this.masterData.form_c.project_section.result_quantity =
            "ทดสอบเชิงปริมาณ";
          this.masterData.form_c.project_section.result_quality =
            "ทดสอบเชิงคุณภาพ";

          // จำนวนผู้ประกอบการที่สำเร็จการบ่มเพาะ (สำหรับ final version)
          if (this.isFinal) {
            this.masterData.form_c.completed_incubation_company = [
              {
                participants_year: "2567",
                participants_count: "10",
              },
              {
                participants_year: "2566",
                participants_count: "8",
              },
            ];
          }

          // ตารางสรุปผู้ประกอบการที่อยู่ระหว่างกระบวนบ่มเพาะธุรกิจ วทน.
          this.masterData.form_c.incubation_companies = [
            {
              fiscal_year: "2567",
              university_id: 1,
              university_name: "มหาวิทยาลัยทดสอบ",
              product: "ผลิตภัณฑ์นวัตกรรมทดสอบ",
              company: "บริษัททดสอบ จำกัด",
              technology_type: "อุตสาหกรรมดิจิตอล (Digital)",
              technology_type_other: "",
              status: "บ่มเพาะธุระกิจ วทน. ปีที่ 1",
            },
            {
              fiscal_year: "2566",
              university_id: 2,
              university_name: "มหาวิทยาลัยทดสอบ 2",
              product: "ผลิตภัณฑ์เทคโนโลยีชีวภาพ",
              company: "บริษัทชีวภาพ จำกัด",
              technology_type:
                "การเกษตรและเทคโนโลยีชีวภาพ (Agriculture and Biotechnology)",
              technology_type_other: "",
              status: "บ่มเพาะธุระกิจ วทน. ปีที่ 2",
            },
          ];
          console.log(
            "this.masterData.kpi_masters",
            this.masterData.kpi_masters
          );
          // KPI Values สำหรับ STI
          if (this.masterData.kpi_masters) {
            this.masterData.kpi_masters.forEach((kpiMaster) => {
              kpiMaster.kpi_sub_masters.forEach((subMaster) => {
                if (!subMaster.kpi_sub_values) {
                  subMaster.kpi_sub_values = {
                    id: Math.floor(Math.random() * 1000),
                    kpi_sub_master_id: subMaster.id,
                    kpi_sub_value: Math.floor(Math.random() * 100) + 1,
                    description: "คำอธิบายทดสอบ",
                  };
                }
              });
            });
          }
        } else if (plan_code === "SP") {
          // ผลลัพธ์
          this.masterData.form_c.project_section.result_quantity =
            "ทดสอบผลลัพธ์เชิงปริมาณ";
          this.masterData.form_c.project_section.result_quality =
            "ทดสอบผลลัพธ์เชิงคุณภาพ";

          // ผลผลิตและตัวชี้วัดความสำเร็จ
          this.masterData.form_c.project_section.kpi_eco =
            "ทดสอบตัวชี้วัดเชิงเศรษฐกิจ";
          this.masterData.form_c.project_section.kpi_social =
            "ทดสอบตัวชี้วัดเชิงสังคม";

          // ผลกระทบ
          this.masterData.form_c.project_section.impact_quantity =
            "ทดสอบผลกระทบเชิงปริมาณ/เชิงเศรษฐกิจของภูมิภาค";
          this.masterData.form_c.project_section.impact_quality =
            "ทดสอบผลกระทบเชิงคุณภาพ/เชิงสังคม";

          // KPI Values สำหรับ SP
          if (this.masterData.kpi_masters) {
            this.masterData.kpi_masters.forEach((kpiMaster) => {
              kpiMaster.kpi_sub_masters.forEach((subMaster) => {
                if (!subMaster.kpi_sub_values) {
                  subMaster.kpi_sub_values = {
                    id: Math.floor(Math.random() * 1000),
                    kpi_sub_master_id: subMaster.id,
                    kpi_sub_value: Math.floor(Math.random() * 100) + 1,
                    description: "คำอธิบายทดสอบ",
                  };
                }
              });
            });
          }
        } else if (plan_code === "CR") {
          // ผลผลิตและตัวชี้วัดความสำเร็จ
          this.masterData.form_c.project_section.s4_p2_eco =
            "ทดสอบผลผลิตเชิงเศรษฐกิจ";
          this.masterData.form_c.project_section.s4_p2_social =
            "ทดสอบผลผลิตเชิงสังคม";

          // ผลลัพธ์ที่ได้จากโครงการ
          this.masterData.form_c.project_section.s4_p3_result =
            "ทดสอบผลลัพธ์ที่ได้จากโครงการ";

          // ผลกระทบ
          this.masterData.form_c.project_section.s4_p4_quantity =
            "ทดสอบผลกระทบเชิงคุณภาพ/เชิงสังคม";
          this.masterData.form_c.project_section.s4_p4_quality =
            "ทดสอบผลกระทบเชิงปริมาณ/เชิงเศรษฐกิจของภูมิภาค";

          // ประโยชน์ที่ได้รับ
          this.masterData.form_c.project_section.s4_p5_quality =
            "ทดสอบประโยชน์เชิงคุณภาพ";
          this.masterData.form_c.project_section.s4_p5_quantity =
            "ทดสอบประโยชน์เชิงปริมาณ";

          // KPI Values สำหรับ CR
          if (this.masterData.kpi_masters) {
            this.masterData.kpi_masters.forEach((kpiMaster) => {
              kpiMaster.kpi_sub_masters.forEach((subMaster) => {
                if (!subMaster.kpi_sub_values) {
                  subMaster.kpi_sub_values = {
                    id: Math.floor(Math.random() * 1000),
                    kpi_sub_master_id: subMaster.id,
                    kpi_sub_value: Math.floor(Math.random() * 100) + 1,
                    description: "คำอธิบายทดสอบ",
                  };
                }
              });
            });
          }
        } else if (plan_code === "IRTC") {
          // ผลลัพธ์
          this.masterData.form_c.project_section.s4_p3_quantity =
            "ทดสอบผลลัพธ์เชิงปริมาณ";
          this.masterData.form_c.project_section.s4_p3_quality =
            "ทดสอบผลลัพธ์เชิงคุณภาพ";

          // ประโยชน์ที่ได้รับ
          this.masterData.form_c.project_section.s4_p4_quantity =
            "ทดสอบประโยชน์เชิงปริมาณ";
          this.masterData.form_c.project_section.s4_p4_quality =
            "ทดสอบประโยชน์เชิงคุณภาพ";

          // การประเมินผลกระทบด้านเศรษฐกิจ
          this.masterData.form_c.project_section.s4_p4_revenue = "1000000";
          this.masterData.form_c.project_section.s4_p4_revenue_desc =
            "คาดการณ์รายได้เพิ่มขึ้น";

          this.masterData.form_c.project_section.s4_p4_mgm_cost = "500000";
          this.masterData.form_c.project_section.s4_p4_mgm_cost_desc =
            "ต้นทุนการบริหารจัดการ";

          this.masterData.form_c.project_section.s4_p4_prod_cap = "800000";
          this.masterData.form_c.project_section.s4_p4_prod_cap_desc =
            "การเพิ่มกำลังการผลิต";

          this.masterData.form_c.project_section.s4_p4_investment = "2000000";
          this.masterData.form_c.project_section.s4_p4_investment_desc =
            "มูลค่าการลงทุน R&D";

          // การประเมินผลกระทบด้านสังคม
          this.masterData.form_c.project_section.s4_p4_social_impact_eval =
            "300000";
          this.masterData.form_c.project_section.s4_p4_social_impact_eval_desc =
            "ผลกระทบด้านสังคม";

          // การประเมินผลกระทบด้านวิทยาศาสตร์และเทคโนโลยี
          this.masterData.form_c.project_section.s4_p4_sci_tech_impact_eval =
            "1500000";
          this.masterData.form_c.project_section.s4_p4_sci_tech_impact_eval_desc =
            "ผลกระทบด้านวิทยาศาสตร์และเทคโนโลยี";

          // ความคิดเห็นหากไม่ได้เข้ารับบริการ
          this.masterData.form_c.project_section.s4_p5_opinion =
            "ทดสอบความคิดเห็นหากไม่ได้เข้ารับบริการ";

          // KPI Values สำหรับ IRTC
          if (this.masterData.kpi_masters) {
            this.masterData.kpi_masters.forEach((kpiMaster) => {
              kpiMaster.kpi_sub_masters.forEach((subMaster) => {
                if (!subMaster.kpi_sub_values) {
                  subMaster.kpi_sub_values = {
                    kpi_sub_master_id: subMaster.id,
                    kpi_sub_value: Math.floor(Math.random() * 100) + 1,
                    description: "คำอธิบายทดสอบ",
                  };
                }
              });
            });
          }
        }

        // สำหรับทุก plan_code ที่มี attachments (ภาคผนวก)
        if (plan_code === "STI" || plan_code === "SP") {
          if (!this.masterData.form_c.attachments) {
            this.masterData.form_c.attachments = [];
          }

          // เพิ่มไฟล์ทดสอบสำหรับภาคผนวก
          this.masterData.form_c.attachments.push(
            {
              id: Math.floor(Math.random() * 1000),
              doc_type: "annex",
              file_name: "document_test_1.pdf",
              file_path: "/uploads/test/document_test_1.pdf",
              file_size: "1024000",
            },
            {
              id: Math.floor(Math.random() * 1000),
              doc_type: "annex",
              file_name: "document_test_2.docx",
              file_path: "/uploads/test/document_test_2.docx",
              file_size: "2048000",
            }
          );
        }
      }

      this.updateSubFormComponent();
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="scss">
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
